import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "flex flex-col"
};
const _hoisted_2 = {
  class: "w-full flex items-center leading-4"
};
const _hoisted_3 = {
  class: "grow mr-2"
};
const _hoisted_4 = {
  class: "flex items-center w-full mb-0.5"
};
const _hoisted_5 = {
  class: "rounded overflow-hidden flex items-stretch mr-1"
};
const _hoisted_6 = {
  class: "text-center"
};
const _hoisted_7 = {
  key: 0,
  class: "flex-center"
};
import { YouthPlayerScoutingEvaluator } from "@/modules/youth/services/evaluators/YouthPlayerScoutingEvaluator";
import Flag from "@/modules/vue/components/Flag.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import Progress from "@/modules/vue/components/Progress.vue";
import Status from "@/modules/vue/components/Status.vue";
import { ColorEnum } from "@/modules/vue/enums";
import Gate from "@/modules/action-points/components/Gate.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import Talent from "@/modules/youth/components/Talent.vue";
import Position from "@/modules/team/components/Position.vue";
import Skill from "@/modules/team/components/Skill.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YouthPlayerSlim',
  props: {
    player: null
  },
  emits: ['updated'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const cost = computed(() => app.get(ConfigRepository).get('scouting.actionPointsCosts.youthPlayer'));
    const canBeScouted = computed(() => !props.player.recruitedBy && !props.player.isFullyRevealed);
    const onScoutingAction = async commit => {
      await app.get(YouthPlayerScoutingEvaluator).evaluate(props.player);
      await commit();
      emit('updated');
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [!__props.player.canSee('name') ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        icon: _ctx.IconEnum.QuestionCircle32Regular,
        class: "my-2"
      }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(Talent, {
        talent: __props.player.revealedTalent,
        class: "mr-0.5"
      }, null, 8, ["talent"]), _createElementVNode("div", _hoisted_5, [_createVNode(Position, {
        position: __props.player.canSee('position') ? __props.player.position : undefined
      }, null, 8, ["position"]), _createVNode(Skill, {
        skill: __props.player.canSee('skill') ? __props.player.skill : undefined
      }, null, 8, ["skill"])]), _createVNode(Flag, {
        country: __props.player.country,
        class: "mr-1"
      }, null, 8, ["country"]), _createVNode(EntityLink, {
        entity: __props.player
      }, null, 8, ["entity"])], 64))]), _createVNode(Progress, {
        value: __props.player.revelation
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_unref(canBeScouted) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(Gate, {
        type: _unref(GateTypeEnum).SCOUTING,
        value: _unref(cost),
        "no-confirm": "",
        onAction: onScoutingAction
      }, null, 8, ["type", "value"])])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [__props.player.isFullyRevealed ? (_openBlock(), _createBlock(Status, {
        key: 0,
        value: _ctx.$t('scouted'),
        color: _unref(ColorEnum).Green,
        class: "mx-2"
      }, null, 8, ["value", "color"])) : __props.player.recruitedBy && __props.player.recruitedBy.isCurrent ? (_openBlock(), _createBlock(Status, {
        key: 1,
        value: "recruited",
        color: _unref(ColorEnum).Green,
        class: "mx-2"
      }, null, 8, ["color"])) : (_openBlock(), _createBlock(Status, {
        key: 2,
        value: "unavailable",
        color: _unref(ColorEnum).Red,
        class: "mx-2"
      }, null, 8, ["color"]))], 64))])])]);
    };
  }
});